export default function batchLoadMore() {
  const containers = document.querySelectorAll('.batch-load-more')
  if (!containers.length) return

  containers.forEach(container => {
    const batches = Array.from(container.querySelectorAll('.batch'))
    const button = container.querySelector('.js-show-more')
    const totalBatches = button ? parseInt(button.dataset.totalBatches, 10) : batches.length

    let visibleBatches = 1

    // Hide all batches except the first
    batches.forEach((batch, i) => {
      if (i >= visibleBatches) batch.style.display = 'none'
    })

    if (button) {
      button.addEventListener('click', () => {
        if (visibleBatches < totalBatches) {
          batches[visibleBatches].style.display = ''
          visibleBatches++

          // Hide button if all batches are visible
          if (visibleBatches >= totalBatches) {
            button.style.display = 'none'
          }
        }
      })
    }
  })
}
